import React, {useState, useEffect, useRef} from 'react';
import axios from "axios";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import '../../css/DataTableDemo.css';
import {TabView, TabPanel} from 'primereact/tabview';
import {Chart} from 'primereact/chart';


const CmsContentStatistic = state => {
    const [contCountNews, setContCountNews] = useState(0);
    const [contCountActivity, setContCountActivity] = useState(0);
    const [contCountNotification, setContCountNotification] = useState(0);
    const [contCountArticle, setContCountArticle] = useState(0);
    const [contentListAll, setContentListAll] = useState([]);
    const [contCountModule, setContCountModule] = useState(0);
    const [contCountModule2, setContCountModule2] = useState(0);
    const [contCountModule3, setContCountModule3] = useState(0);
    const [contCountModule4, setContCountModule4] = useState(0);
    const [contCountModule5, setContCountModule5] = useState(0);
    const [contCountModule6, setContCountModule6] = useState(0);
    const [contViewNews, setContViewNews] = useState(0);
    const [contViewActivity, setContViewActivity] = useState(0);
    const [contViewNotification, setContViewNotification] = useState(0);
    const [contViewArticle, setContViewArticle] = useState(0);
    const [contFavNews, setContFavNews] = useState(0);
    const [contFavActivity, setContFavActivity] = useState(0);
    const [contFavNotification, setContFavNotification] = useState(0);
    const [contFavArticle, setContFavArticle] = useState(0);
    const [contentListFav, setContentListFav] = useState([]);
    const [contentListView, setContentListView] = useState([]);


    const statistic_list_role = !!localStorage.getItem('statistic_list_role');

    useEffect(() => {

        getContentListAll()
        getContentStatistic()


    }, []);


    const getContentListAll = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/dashboard/', {"headers": headers})
            .then(res => {
                    setContentListAll(res.data.CmsContent)
                    setContCountNews(res.data.CmsContent[0].count_content_news)
                    setContCountActivity(res.data.CmsContent[0].count_content_activity)
                    setContCountNotification(res.data.CmsContent[0].count_content_notification)
                    setContCountArticle(res.data.CmsContent[0].count_content_article)
                    setContentListAll(res.data.CmsContent)
                    setContCountModule(res.data.CmsContent[0].count_module_platform)
                    setContCountModule2(res.data.CmsContent[0].count_module_butunportaller)
                    setContCountModule3(res.data.CmsContent[0].count_module_y3portal)
                    setContCountModule4(res.data.CmsContent[0].count_module_verikovani)
                    setContCountModule5(res.data.CmsContent[0].count_module_degirmen)
                    setContCountModule6(res.data.CmsContent[0].count_module_modelegitim)

                }
            )

    }
    const getContentStatistic = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/cms_content_statistic/', {"headers": headers})
            .then(res => {
                    const data = res.data.statistic_list
                    setContentListFav(res.data.count_fav_total)
                    setContentListView(res.data.count_view_total)
                    for (let i = 0; i < data.length; i++) {
                        const file = data[i];
                        setContViewNews(file.count_view_news)
                        setContViewActivity(file.count_view_activity)
                        setContViewNotification(file.count_view_notification)
                        setContViewArticle(file.count_view_article)
                        setContFavArticle(file.count_fav_article)
                        setContFavNotification(file.count_fav_notification)
                        setContFavNews(file.count_fav_news)
                        setContFavActivity(file.count_fav_activity)
                    }
                }
            )

    }

    const chartData = {
        labels: ['Haber', 'Etkinlik', 'Duyuru', 'Makale/Blog'],
        datasets: [
            {
                data: [contViewNews, contViewActivity, contViewNotification, contViewArticle],
                backgroundColor: [
                    "#42A5F5",
                    "#66BB6A",
                    "#FFA726",
                    "#26ebff"
                ],
                hoverBackgroundColor: [
                    "#64B5F6",
                    "#81C784",
                    "#FFB74D"
                ]
            }
        ]
    };

    const chartData5 = {
        labels: ['Haber', 'Etkinlik', 'Duyuru', 'Makale/Blog'],
        datasets: [
            {
                data: [contFavNews, contFavActivity, contFavNotification, contFavArticle],
                backgroundColor: [
                    "#42A5F5",
                    "#66BB6A",
                    "#FFA726",
                    "#26ebff"
                ],
                hoverBackgroundColor: [
                    "#64B5F6",
                    "#81C784",
                    "#FFB74D"
                ]
            }
        ]
    };

    const lightOptions = {
        bezierCurve: false,
        // onAnimationComplete: done,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    };

    let all_table_header_tabpanel = (
        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>İstatistiki Tablolar</b></h6>

        </div>
    );
    let all_table_header_tabpanel2 = (
        <div className="p-mt-1">
            <h6 className="p-mb-2"><b>İstatistiki Grafikler</b></h6>

        </div>
    );


    const imageDownload = (id) => {
        const div = document.getElementById(id)
        const canvas = div.getElementsByTagName("canvas");
        if (canvas.length > 0) {
            let image = canvas[0].toDataURL("image/png", 1.0).replace("image/png", "image/octet-stream");
            const link = document.createElement('a');
            link.download = "statistic.png";
            link.href = image;
            link.click();
        }

    }
    const imageDownload2 = (id) => {
        const div = document.getElementById(id)
        const canvas = div.getElementsByTagName("canvas");
        if (canvas.length > 0) {
            let image = canvas[0].toDataURL("image/png", 1.0).replace("image/png", "image/octet-stream");
            const link = document.createElement('a');
            link.download = "statistic.jpg";
            link.href = image;
            link.click();
        }

    }
    const revenueChart = {
        labels: ['Haber', 'Etkinlik', 'Duyuru', 'Makale/Blog'],
        datasets: [
            {
                data: [contCountNews, contCountActivity, contCountNotification, contCountArticle],
                backgroundColor: ['#64B5F6', '#7986CB', '#4DB6AC', '#64f6ee']
            }
        ]
    };
    const revenueChart2 = {
        labels: ['Platform', 'Tüm Portaller', 'Y3', 'Veri Kovanı', 'Değirmen', 'Model Eğitim Portali'],
        datasets: [
            {
                data: [contCountModule, contCountModule2, contCountModule3, contCountModule4, contCountModule5, contCountModule6],
                backgroundColor: ["#42A5F5",
                    "#7986CB",
                    "#FF6384",
                    "#FFCE56", '#64f6ee', '#4DB6AC']
            }
        ]
    };


    if (statistic_list_role) {

        return (
            <div className="layout-dashboard">
                <TabView className="tabview-custom">
                    <TabPanel header={all_table_header_tabpanel2} classname="p-mr-2" leftIcon="pi pi-chart-bar p-mr-2">
                        <div className="p-grid">


                            <div className="p-col-12 p-xl-6">
                                <div className="card revenue">
                                    <h4>İçerik Türlerine Göre Görüntüleme Sayıları</h4>
                                    <p>Görüntülenen içeriklerin içerik türlerine göre dağılımı</p>
                                    <div className="revenue-chart-container" align="center">
                                        <div align="right" className="p-mb-5">
                                            <Button label="png" icon="pi pi-download"
                                                    onClick={() => imageDownload("pieChart")}/>
                                            <Button label="jpg" icon="pi pi-download"
                                                    className="p-button-success p-ml-3"
                                                    onClick={() => imageDownload2("pieChart")}/>

                                        </div>


                                        <Chart type="pie"
                                               id="pieChart"
                                               data={chartData}
                                               options={lightOptions}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="p-col-12 p-xl-6">
                                <div className="card revenue">
                                    <h4>İçerik Tür Dağılımı</h4>
                                    <p>Tüm içerikler baz alınarak yapılmıştır</p>
                                    <div className="revenue-chart-container" align="center">
                                        <div align="right" className="p-mb-5">
                                            <Button label="png" icon="pi pi-download"
                                                    onClick={() => imageDownload("pieChart3")}/>
                                            <Button label="jpg" icon="pi pi-download"
                                                    className="p-button-success p-ml-3"
                                                    onClick={() => imageDownload2("pieChart3")}/>
                                        </div>


                                        <Chart type="pie" id="pieChart3"
                                               data={revenueChart}
                                        >

                                        </Chart>

                                    </div>
                                </div>
                            </div>

                            <div className="p-col-12 p-xl-6">
                                <div className="card revenue">
                                    <h4>İçerik Modül Dağılımı</h4>
                                    <p>Eklenen içeriklerin modüllere göre dağılımı.</p>
                                    <div className="revenue-chart-container" align="center">
                                        <div align="right" className="p-mb-5">
                                            <Button label="png" icon="pi pi-download"
                                                    onClick={() => imageDownload("pieChart4")}/>
                                            <Button label="jpg" icon="pi pi-download"
                                                    className="p-button-success p-ml-3"
                                                    onClick={() => imageDownload2("pieChart4")}/>

                                        </div>


                                        <Chart type="pie" id="pieChart4"
                                               data={revenueChart2}

                                        >

                                        </Chart>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="p-col-12 p-xl-6">*/}
                            {/*    <div className="card revenue">*/}
                            {/*        <h4>İçerik Türlerine Göre Favorilenme Sayıları</h4>*/}
                            {/*        <p>Favorilenen içeriklerin içerik türlerine göre dağılımı</p>*/}
                            {/*        <div className="revenue-chart-container" align="center">*/}
                            {/*            <div align="right" className="p-mb-5">*/}
                            {/*                <Button label="png" icon="pi pi-download"*/}
                            {/*                        onClick={() => imageDownload("pieChart2")}/>*/}
                            {/*                <Button label="jpg" icon="pi pi-download"*/}
                            {/*                        className="p-button-success p-ml-3"*/}
                            {/*                        onClick={() => imageDownload2("pieChart2")}/>*/}
                            {/*            </div>*/}


                            {/*            <Chart type="pie" id="pieChart2" data={chartData5}*/}
                            {/*                   options={lightOptions}*/}
                            {/*            />*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*</div>*/}


                        </div>
                    </TabPanel>
                    <TabPanel header={all_table_header_tabpanel} classname="p-mr-2" leftIcon="pi pi-calendar p-mr-2">
                        <div className="datatable-responsive-demo p-mt-5">

                            <div className="card">
                                <h4>En Çok Okunan İçerikler</h4>
                                <p>En çok görüntülenen içerikler</p>
                                <DataTable
                                    value={contentListView}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={5} dataKey="id"
                                    rowHover
                                    emptyMessage="Kayıt bulunamadı"
                                >


                                    <Column
                                        field={'cont_id'}
                                        style={{textAlign: 'center', width: '5em'}}
                                        header="No"


                                    />
                                    <Column field={'cont__cont_title'}
                                            header="Başlık"
                                            style={{textAlign: 'left', fontWeight: 'bold'}}
                                            filter
                                    />
                                    <Column
                                        field={'cont__ctyp__ctyp_name'}
                                        header="İçerik Türü"
                                        filter


                                        style={{textAlign: 'center'}}/>
                                    <Column field={'cont__md__md_name'}
                                            header="Yayımlanan Modül"
                                            style={{textAlign: 'center'}}
                                            filter
                                    />
                                    {/*<Column field={'cont__user__user_username'}*/}
                                    {/*        header="Kullanıcı Adı"*/}
                                    {/*        style={{textAlign: 'center'}}*/}
                                    {/*        filter*/}
                                    {/*/>*/}
                                    <Column field={'count'}
                                            header="Görüntülenme Sayısı"
                                            style={{textAlign: 'center'}}
                                            sortable
                                    />

                                </DataTable>
                            </div>
                        </div>
                        {/*<div className="datatable-responsive-demo p-mt-5">*/}

                        {/*    <div className="card">*/}
                        {/*        <h4>En Çok Favorilenen İçerikler</h4>*/}
                        {/*        <p>En popüler içerikler</p>*/}

                        {/*        <DataTable*/}
                        {/*            value={contentListFav}*/}
                        {/*            paginator*/}
                        {/*            className="p-datatable-responsive-demo"*/}
                        {/*            rows={5} dataKey="id"*/}
                        {/*            rowHover*/}
                        {/*            emptyMessage="Kayıt bulunamadı"*/}
                        {/*        >*/}

                        {/*            <Column*/}
                        {/*                field={'cont_id'}*/}
                        {/*                style={{textAlign: 'center', width: '5em'}}*/}
                        {/*                header="No"*/}


                        {/*            />*/}
                        {/*            <Column field={'cont__cont_title'}*/}
                        {/*                    header="Başlık"*/}
                        {/*                    style={{textAlign: 'left', fontWeight: 'bold'}}*/}
                        {/*                    filter*/}
                        {/*            />*/}
                        {/*            <Column*/}
                        {/*                field={'cont__ctyp__ctyp_name'}*/}
                        {/*                header="İçerik Türü"*/}
                        {/*                filter*/}


                        {/*                style={{textAlign: 'center'}}/>*/}
                        {/*            <Column field={'cont__md__md_name'}*/}
                        {/*                    header="Yayımlanan Modül"*/}
                        {/*                    style={{textAlign: 'center'}}*/}
                        {/*                    filter*/}
                        {/*            />*/}
                        {/*            /!*<Column field={'cont__user__user_username'}*!/*/}
                        {/*            /!*        header="Kullanıcı Adı"*!/*/}
                        {/*            /!*        style={{textAlign: 'center'}}*!/*/}
                        {/*            /!*        filter*!/*/}
                        {/*            />*/}
                        {/*            <Column field={'count'}*/}
                        {/*                    header="Favorilenme Sayısı"*/}
                        {/*                    style={{textAlign: 'center'}}*/}
                        {/*                    sortable*/}
                        {/*            />*/}

                        {/*        </DataTable>*/}
                        {/*    </div>*/}
                        {/*</div>*/}


                    </TabPanel>

                </TabView>
            </div>

        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
export default CmsContentStatistic;


// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsContentStatistic.jsx